import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`現為街口電子支付技術團隊負責人，先前曾服務於杭州阿里巴巴、台灣 HTC 等國際級企業，熟悉大規模高可用高併發應用系統架構。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      